import React from 'react';

import { NavLink } from 'react-router-dom';

const Footer = () => {
  return (
    
  <div className="footer">
    <div className='date'><p>Copyright © 2025 OCD New York. All rights reserved.</p></div>
    <div className='logo'>
      <a href = "http://www.marknycweb.com/" target='_blank'><img src='/images/marknycweb_logo.png' /></a>
    </div>
  </div>
  
  );
}

export default Footer;